<template>
    <CModal
      :color="color"
      size="sm"
      :show.sync="showModal"
    >
    <template #header>
      <CRow style="width: 100%; height: 5px;">
        <CCol md="9">{{title}}</CCol>
        <CCol md="3"></CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>
    </template>
      <CRow>
        <CCol md="12">
          <CInput
            type="number"
            label="Nuevo monto:"
            :lazy="false"
            :value.sync="budget"
            name="budget"
            id="budget"
            step="0.01"
            min="0"
          />
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="closeModal" color="secondary">Cancelar</CButton>
        <CButton @click="changeBudget" :color="color">Guardar</CButton>
      </template>
    </CModal>
</template>

<script>
import store from '../../store';
import ws from '../../services/freelancers';

export default {
  name: 'ChangeVisitBudgetModal',
  data () {
    return {
      showModal: false,
      title: 'Monto por Pagar',
      color: 'info',
      submitted: false,
      visit: false,
      budget: ''
    }
  },
  methods: {
    async showVisitModal (visit) {
      this.visit = visit;
      this.budget = visit && visit.budget ? Number(visit.budget).toFixed(2) : '';

      this.loading();

      this.showModal = true;
      this.color = 'info';
      this.title = 'Monto por Pagar';
      this.submitted = false;

      this.loaded();
    },
    async changeBudget () {
      if(this.budget === '' || this.budget === null){
        this.showToast('error', 'Debe indicar un monto válido.');
        return;
      }

      if(Number(this.budget) < 0){
        this.showToast('error', 'El monto no puede ser negativo.');
        return;
      }

      this.loading();

      let response = await ws.changeVisitBudget({id: this.visit.id, budget: this.budget});

      this.closeModal();

      if(response.type == 'success'){
        this.showToast('success', 'El monto de la visita fue actualizado correctamente.');
        this.$emit('refresh');
      }
      else{
        this.showToast('error', response.message);
      }

      this.loaded();
    },
    closeModal () {
      this.showModal = false;
      this.submitted = false;
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>

<style>
</style>
